/**
 * DefaultPageSize
 *
 * @description Default pagination page size
 */
export const defaultPageSize = 10;

/**
 * DateTimeFormat
 *
 * @description Date time format to send date range to api: 2023-10-15
 */
export const dateTimeFormat = 'YYYY-MM-DD';